import { render, staticRenderFns } from "./NewVariableInput.vue?vue&type=template&id=fdcb6ede&scoped=true&"
import script from "./NewVariableInput.vue?vue&type=script&lang=ts&"
export * from "./NewVariableInput.vue?vue&type=script&lang=ts&"
import style0 from "./NewVariableInput.vue?vue&type=style&index=0&id=fdcb6ede&lang=scss&scoped=true&"
import style1 from "./NewVariableInput.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcb6ede",
  null
  
)

export default component.exports